<template>
	<div>
		<div v-for="factor in selectedFactors" class="tw-mb-6 tw-text-center">
			<weighing-factor-progress-bar
				:factor="factor"
				:combinations="combinations"
				complete-position="bottom"
			>
				<template slot="factor-percentage">{{ getFactorWeighingSum(factor) }} / {{ getRelativePercentage(factor) }}%</template>
			</weighing-factor-progress-bar>
		</div>
	</div>
</template>

<script>
import WeighingFactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/WeighingFactorProgressBar';
import { factorWeighingSum, totalSumWeighings, getPercentageByValue } from '@/modules/job-evaluation/utils/valuation-model/factors';

export default {
	name: 'WeighFactorList',
	components: { WeighingFactorProgressBar },
	props: ['selectedFactors', 'combinations'],
	methods: {
		getFactorWeighingSum(factor) {
			return factorWeighingSum(factor, this.combinations);
		},
		getRelativePercentage(factor) {
			const factorSum = factorWeighingSum(factor, this.combinations);
			const totalSum = totalSumWeighings(this.combinations);
			return getPercentageByValue(factorSum, totalSum);
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighFactorList.vue